'use strict';

import angular from 'angular';
const translateModule = 'pascalprecht.translate';

import { API_CONFIG } from './api-config.constants';

import { uiRouterConfig } from './router.config';

import { $httpProviderConfig } from './http.config';
import { xsrfConfig } from './xsrf.config';

import {
  productCustomizerConfig,
  productPreferencesConfig
} from './customization.config';

import iconsConfig from './icons.config';


import { i18nConfig } from './i18n.config';       // todo move to FeCon

import messages_it from '../i18n/messages_it';
import messages_en from '../i18n/messages_en';
import { feconIsacConfig } from './isac.config';        // isac-integration
export default angular.module('product.config', [
  translateModule
])
  // back-end api constants
  .constant('API_CONFIG', API_CONFIG)

  // ui router config
  .config(uiRouterConfig)

  // $http service global configuration
  .config($httpProviderConfig)

  // xsrf protection
  .config(xsrfConfig)

  // customizations, preferences
  .config(productCustomizerConfig)
  .config(productPreferencesConfig)

  // initial icons
  .config(iconsConfig)
  // fecon-isac config - (after ui router config)       // isac-integration
  .config(feconIsacConfig)                              // isac-integration
  // i18n
  .constant('messages_it', messages_it)
  .constant('messages_en', messages_en)
  .config(i18nConfig)


  // return the angular module name for all app.config bundle
  .name;



// WEBPACK FOOTER //
// ./client/app/app.config/index.js